import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import StatusPill from "@/components/common/StatusPill";
import { toast } from "sonner";
import { messaggioErrore } from "@/lib/preventivi";


export default function RecensioniTab() {
  const [imp, setImp] = useState({ numero_totale: "", media: "" });
  const [rows, setRows] = useState([]);
  const [busyImp, setBusyImp] = useState(false);

  const load = async () => {
    try {
      const [i, r] = await Promise.all([
        api.get("/impostazioni/recensioni"),
        api.get("/recensioni"),
      ]);
      setImp({ numero_totale: i.data.numero_totale || "", media: i.data.media || "" });
      setRows(r.data || []);
    } catch (e) { toast.error(messaggioErrore(e)); }
  };
  useEffect(() => { load(); }, []);

  const salvaImp = async () => {
    setBusyImp(true);
    try {
      await api.put("/impostazioni/recensioni", imp);
      toast.success("Impostazioni salvate");
      await load();
    } catch (e) { toast.error(messaggioErrore(e)); }
    finally { setBusyImp(false); }
  };

  const active = rows.filter((r) => r.attiva && r.verbatim);
  const byFonte = rows.reduce((acc, r) => {
    acc[r.fonte || "—"] = (acc[r.fonte || "—"] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="space-y-6" data-testid="recensioni-tab">
      <Card className="p-card space-y-3">
        <div>
          <p className="text-sm font-semibold text-foreground">Numeri pubblici — dal profilo Google</p>
          <p className="text-xs text-muted-foreground mt-1">
            Vanno nel blocco «perché noi» come lettura in tempo reale, non come testo statico nel documento.
            Cambia questi due valori quando cambiano su Google.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="space-y-inside">
            <Label className="text-xs text-muted-foreground">Numero totale recensioni</Label>
            <Input value={imp.numero_totale} onChange={(e) => setImp({ ...imp, numero_totale: e.target.value })}
                   placeholder="es. 148" data-testid="imp-numero" />
          </div>
          <div className="space-y-inside">
            <Label className="text-xs text-muted-foreground">Media (su 5)</Label>
            <Input value={imp.media} onChange={(e) => setImp({ ...imp, media: e.target.value })}
                   placeholder="es. 4,9" data-testid="imp-media" />
          </div>
        </div>
        <Button onClick={salvaImp} disabled={busyImp} data-testid="imp-save">
          Salva
        </Button>
      </Card>

      <Card className="overflow-hidden">
        <div className="bg-muted px-4 py-2.5 border-b flex items-center justify-between flex-wrap gap-2">
          <div>
            <p className="text-eyebrow uppercase text-muted-foreground">
              Libreria recensioni ({rows.length} totali · {active.length} verbatim attive)
            </p>
            <p className="text-xs text-muted-foreground">
              Per fonte: {Object.entries(byFonte).map(([k, v]) => `${k}=${v}`).join(" · ") || "—"}
            </p>
          </div>
          <Badge variant="outline" className="text-xs">Sola lettura da UI · carica via script/DB</Badge>
        </div>
        {rows.length === 0 ? (
          <div className="p-6 text-sm text-muted-foreground text-center">
            La libreria è vuota. Carica le recensioni verificate (fonte Google) tramite lo script di import.
          </div>
        ) : (
          <ul className="divide-y divide-border max-h-[480px] overflow-auto">
            {rows.slice(0, 200).map((r) => (
              <li key={r.id} className="px-4 py-3 space-y-1" data-testid={`rec-${r.id}`}>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-semibold text-foreground">{r.nome_autore || "—"}</span>
                  {r.data_recensione ? (
                    <span className="text-xs text-muted-foreground">{r.data_recensione}</span>
                  ) : null}
                  {r.rating ? (
                    <span className="text-xs text-warning-foreground">{"\u2605".repeat(r.rating)}</span>
                  ) : null}
                  <Badge variant="outline" className="text-xs uppercase">{r.fonte || "—"}</Badge>
                  {r.verbatim ? (
                    <StatusPill stato="ok" dot={false}>verbatim</StatusPill>
                  ) : null}
                  {!r.attiva ? (
                    <StatusPill stato="errore" dot={false}>nascosta</StatusPill>
                  ) : null}
                </div>
                <p className="text-xs text-foreground whitespace-pre-wrap">{r.testo}</p>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
